import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import { en } from './en/index';
import { frCA } from './fr-CA/index';

export const KnBrasmTranslations: TranslationResources = {
  en,
  fr_CA: frCA,
};

export const KnBrasmTranslationChunksConfig: TranslationChunksConfig = {
  asm: ['asm'],
};
